import { service } from '@ember/service';
import Component from '@glimmer/component';
import type SemeiaSessionService from 'parog-web/services/session';

export default class ProductName extends Component {
  @service declare session: SemeiaSessionService;

  <template>{{this.session.productName}}</template>
}
